import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import toast from "react-hot-toast";
import { decryptData } from "../../utils/storage";
import { RestfullApiService } from "../../config/service";
import {
  disabledCustomStyle,
  selectCustomStyle,
} from "../../utils/selectCustomStyle";
import dayjs from "dayjs";
import {
  Link,
  Stack,
  TextField,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import PaymentDetails from "../Payment/PaymentDetails";
import { MEDIA_URL } from "../../config/url";

const PersonalInfoForm = ({
  form,
  setForm,
  setNextForm,
  Event_Id,
  updateTab,
  user,
}) => {
  const Mandatory_Fields_Array = JSON.parse(
    localStorage.getItem("Mandatory_Fields")
  );
  const [submitStepOne, setSubmitStepOne] = useState(false);
  const [open, setOpen] = useState(false);

  const blood_group = [
    { label: "A+", value: "A+" },
    { label: "A-", value: "A-" },
    { label: "B+", value: "B+" },
    { label: "B-", value: "B-" },
    { label: "O+", value: "O+" },
    { label: "O-", value: "O-" },
    { label: "AB+", value: "AB+" },
    { label: "AB-", value: "AB-" },
  ];
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const validationSchema = Yup.object().shape({
    forms: Yup.array().of(
      Yup.object().shape({
        Name: Mandatory_Fields_Array.includes("PQ001")
          ? Yup.string().required("Name is required")
          : Yup.string().nullable(),
        Phone_Number: Mandatory_Fields_Array.includes("PQ003")
          ? Yup.string()
              .required("Phone number is required")
              .matches(/^[0-9]{10}$/, "Phone number is not valid")
          : Yup.string().nullable(),
        Email_Id: Mandatory_Fields_Array.includes("PQ002")
          ? Yup.string()
              .matches(emailRegex, "Invalid email address")
              .required("Email is required")
          : Yup.string().nullable(),
        Gender: Mandatory_Fields_Array.includes("PQ005")
          ? Yup.string().required("Gender is required")
          : Yup.string().nullable(),
        Date_Of_Birth: Mandatory_Fields_Array.includes("PQ004")
          ? Yup.date().required("Date is required")
          : Yup.date().nullable(),
        Blood_Group: Mandatory_Fields_Array.includes("PQ006")
          ? Yup.object().required("Blood group is required")
          : Yup.object().nullable(),
        sameAsAbove: Yup.boolean(),
        self: Yup.boolean(),
      })
    ),
  });
  const fieldRefs = useRef({}); // Store refs for fields

  const convertToXml = (formData) => {
    let xmlString = "<BookTicket>\n";

    formData.forEach((data) => {
      xmlString += "    <PersonalInfo>\n";
      xmlString += `        <Event_Booking_Participant_Id>${
        data.Event_Booking_Participant_Id
          ? data.Event_Booking_Participant_Id
          : ""
      }</Event_Booking_Participant_Id>\n`;
      xmlString += `        <Event_Category_Id>${data.eventId}</Event_Category_Id>\n`;
      xmlString += `        <First_Name>${data?.Name ?? ""}</First_Name>\n`;
      xmlString += `        <Last_Name>${""}</Last_Name>\n`;
      xmlString += `        <Phone>${data.Phone_Number ?? ""}</Phone>\n`;
      xmlString += `        <Email>${data.Email_Id ?? ""}</Email>\n`;
      xmlString += `        <Gender>${
        data.Gender === "Male"
          ? "M"
          : data.Gender === "Female"
          ? "F"
          : data.Gender === "Other"
          ? "O"
          : ""
      }</Gender>\n`;
      xmlString += `        <BloodGroup>${
        data.Blood_Group.value ? data.Blood_Group.value : ""
      }</BloodGroup>\n`;
      xmlString += `        <DateofBirth>${
        data.Date_Of_Birth ? dayjs(data.Date_Of_Birth).format("YYYY-MM-DD") : ""
      }</DateofBirth>\n`;
      xmlString += "    </PersonalInfo>\n";
    });

    xmlString += "</BookTicket>";
    return xmlString;
  };
  const submitStep1 = async (formValues) => {
    // const user = JSON.parse(localStorage.getItem("userProf"));
    const Booking_Id = localStorage.getItem("Booking_Id");
    const xml = convertToXml(formValues);
    const reqdata = {
      Method_Name: "Step1",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Participant_Id: user?.Participant_Id,
      Booking_Id: Booking_Id,
      Event_Id: decryptData(Event_Id),
      XMLData: xml,
      Coupon_Code: "",
    };
    try {
      setSubmitStepOne(true);

      const result = await RestfullApiService(
        reqdata,
        "participant/book_event"
      );
      if (result?.data?.Result?.Table1[0]?.Result_Id === -1) {
        toast.error(result?.data?.Result?.Table1[0]?.Result_Description);
        return;
      }
      if (result) {
        const genderMap = {
          M: "Male",
          F: "Female",
          O: "Other",
        };
        const updatedFormSubmissionArray = formValues.map(
          (submission, index) => {
            const resultData = result?.data?.Result?.Table2[index];

            if (resultData) {
              submission.Event_Booking_Participant_Id =
                resultData.Event_Booking_Participant_Id;
              submission.Org_Id = resultData.Org_Id;
              submission.Gender =
                genderMap[resultData.Gender] || submission.Gender;
              submission.Event_Price = resultData.Event_Price;
            }

            return submission;
          }
        );
        // Set Current Form
        setForm({ forms: updatedFormSubmissionArray });
        localStorage.setItem(
          "Step1",
          JSON.stringify(updatedFormSubmissionArray)
        );
        localStorage.setItem(
          "Mandatory_Fields",
          JSON.stringify(
            result?.data?.Result?.Table3?.map((field) => field.Question_Id)
          )
        );
        console.log(updatedFormSubmissionArray);
        // Set Next Form Initial Values
        const addressForm = updatedFormSubmissionArray.map((participant) => ({
          Display_Name: participant.eventName,
          Event_Booking_Participant_Id:
            participant.Event_Booking_Participant_Id,
          Participant_Name: participant.Name,
          Address: "",
          Street: "",
          Landmark: "",
          Pincode: "",
          City: "",
          State: "",
          Country: { label: "India", value: "India" },
          self: false,
          sameAsAbove: false,
        }));
        setNextForm({ addresses: addressForm });
        sessionStorage.setItem("activetab", 2);
        return updateTab(2);
      }
    } catch (err) {
      toast.error(err?.Result?.Table1[0]?.Result_Description);
    } finally {
      setSubmitStepOne(false);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    const Step1 = JSON.parse(localStorage.getItem("Step1"));

    console.log(Step1);
    if (Step1) {
      setForm({ forms: Step1 });
    }
  }, []);

  console.log(form);

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={form}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          submitStep1(values?.forms);
        }}
      >
        {({
          values,
          isValid,
          dirty,
          setFieldValue,
          setFieldTouched,
          submitForm,
        }) => {
          return (
            <div>
              <Form>
                <FieldArray name="forms">
                  {({ insert, remove, push }) => (
                    <div>
                      {values.forms.map((form, index) => (
                        <div
                          key={index}
                          className={`shadow-2 px-40 lg:px-20 py-40 rounded-16 pb-20 mt-20 mb-20`}
                        >
                          <div className="row justify-between border-bottom-light pb-30 items-center">
                            <div className="col-auto d-flex x-gap-20 items-center">
                              <div className="size-30 rounded-full flex-center bg-yellow-1 text-dark-1 fw-600">
                                {index + 1}
                              </div>
                              <div className="text-14 text-primary fw-600">
                                {form.eventName}
                              </div>
                            </div>
                            {/* {index === 0 ? ( */}
                            <div className="col-auto lg:mt-10">
                              <div className="d-flex items-center">
                                <div className="text-14 lh-12 mr-10">
                                  For Self
                                </div>
                                <div
                                  className={`form-checkbox${
                                    !values.forms[index].self &&
                                    values.forms.some((form) => form.self)
                                      ? " bg-light-grey rounded-6"
                                      : ""
                                  }`}
                                >
                                  <Field
                                    disabled={
                                      !values.forms[index].self &&
                                      values.forms.some((form) => form.self)
                                    }
                                    type="checkbox"
                                    name={`forms.${index}.self`}
                                    value="true"
                                    checked={values.forms[index].self}
                                    onClick={(e) => {
                                      console.log(e.target.checked);
                                      console.log(values.forms[index]);
                                      if (!e.target.checked) {
                                        setFieldValue(
                                          `forms.${index}.Name`,
                                          ""
                                        );
                                        setFieldValue(
                                          `forms.${index}.Phone_Number`,
                                          ""
                                        );
                                        setFieldValue(
                                          `forms.${index}.Email_Id`,
                                          ""
                                        );
                                        setFieldValue(
                                          `forms.${index}.Gender`,
                                          null
                                        );
                                        setFieldValue(
                                          `forms.${index}.Blood_Group`,
                                          null
                                        );
                                        setFieldValue(
                                          `forms.${index}.Date_Of_Birth`,
                                          null
                                        );
                                      } else {
                                        const genderMap = {
                                          M: "Male",
                                          F: "Female",
                                          O: "Other",
                                        };
                                        console.log(user);
                                        setFieldValue(
                                          `forms.${index}.Name`,
                                          `${user?.First_Name} ${user?.Last_Name}`
                                        );
                                        setFieldValue(
                                          `forms.${index}.Phone_Number`,
                                          `${user?.Phone_Number}`
                                        );
                                        setFieldValue(
                                          `forms.${index}.Email_Id`,
                                          `${user?.Email_Id}`
                                        );
                                        if (user?.Gender) {
                                          setFieldValue(
                                            `forms.${index}.Gender`,
                                            genderMap[user?.Gender]
                                          );
                                        }
                                        if (user?.Blood_Group) {
                                          const selectValue = {
                                            label: user?.Blood_Group,
                                            value: user?.Blood_Group,
                                          };
                                          setFieldValue(
                                            `forms.${index}.Blood_Group`,
                                            selectValue
                                          );
                                        } else {
                                          setFieldValue(
                                            `forms.${index}.Blood_Group`,
                                            null
                                          );
                                        }
                                        if (user?.Date_Of_Birth) {
                                          const userDob = dayjs(
                                            user?.Date_Of_Birth
                                          );

                                          // Define minYear and maxYear based on current date
                                          const minYear = dayjs().subtract(
                                            values.forms[index].minYear,
                                            "year"
                                          ); // 75 years ago
                                          const maxYear = dayjs().subtract(
                                            values.forms[index].maxYear,
                                            "year"
                                          ); // 8 years ago

                                          // Check if user's Date of Birth is between minYear and maxYear
                                          if (
                                            userDob.isBetween(
                                              minYear,
                                              maxYear,
                                              null,
                                              "[]"
                                            )
                                          ) {
                                            // If valid, update the event's Date_Of_Birth
                                            setFieldValue(
                                              `forms.${index}.Date_Of_Birth`,
                                              userDob
                                            );
                                          } else {
                                            alert(
                                              "User's age does not meet the eligibility criteria."
                                            );
                                          }
                                        }
                                      }
                                      setTimeout(() => {
                                        setFieldTouched(
                                          `forms.${index}.Name`,
                                          true
                                        );
                                        setFieldTouched(
                                          `forms.${index}.Phone_Number`,
                                          true
                                        );
                                        setFieldTouched(
                                          `forms.${index}.Email_Id`,
                                          true
                                        );
                                        setFieldTouched(
                                          `forms.${index}.Gender`,
                                          true
                                        );
                                        setFieldTouched(
                                          `forms.${index}.Blood_Group`,
                                          true
                                        );
                                        setFieldTouched(
                                          `forms.${index}.Date_Of_Birth`,
                                          true
                                        );
                                      });
                                    }}
                                  />
                                  <div className="form-checkbox__mark">
                                    <div className="form-checkbox__icon fas fa-check"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* // ) : ( // <></>
                            // )} */}
                          </div>
                          <div className="row justify-between pt-20">
                            <div className="col-md-4">
                              <div className="single-field lg:pt-20 y-gap-20">
                                <label className="text-13 fw-500">
                                  Full Name{" "}
                                  {Mandatory_Fields_Array.includes("PQ001") ? (
                                    <sup className="asc">*</sup>
                                  ) : (
                                    <></>
                                  )}
                                </label>
                                <div className="form-control">
                                  <Field
                                    type="text"
                                    className="form-control"
                                    placeholder="Full name"
                                    maxLength="50"
                                    name={`forms.${index}.Name`}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      const { value } = e.target;

                                      const regex = /^[a-zA-Z][a-zA-Z\s]*$/;
                                      // /^[a-zA-Z\s]*$/;
                                      // /^[a-zA-Z\s]+$/;
                                      // /^[a-zA-Z]*$/; IMP
                                      // /[a-zA-Z]+\s*/; IMP

                                      if (!value || regex.test(value)) {
                                        console.log(value);
                                        setFieldValue(
                                          `forms.${index}.Name`,
                                          value
                                        );
                                      } else {
                                        return;
                                      }
                                    }}
                                  />
                                </div>
                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name={`forms.${index}.Name`}
                                  component="div"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="single-field lg:pt-20 y-gap-20">
                                <label className="text-13 fw-500">
                                  Phone Number{" "}
                                  {Mandatory_Fields_Array.includes("PQ003") ? (
                                    <sup className="asc">*</sup>
                                  ) : (
                                    <></>
                                  )}
                                </label>
                                <div className="form-control">
                                  <Field
                                    type="tel"
                                    className="form-control"
                                    placeholder="000 000 0000"
                                    name={`forms.${index}.Phone_Number`}
                                    maxLength="10"
                                    disabled={values.forms[index].self}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      const { value } = e.target;

                                      // Regular expression to allow only numbers
                                      const regex = /^[0-9\b]+$/;

                                      if (
                                        !value ||
                                        regex.test(value.toString())
                                      ) {
                                        setFieldValue(
                                          `forms.${index}.Phone_Number`,
                                          value
                                        );
                                      } else {
                                        return;
                                      }
                                    }}
                                  />
                                </div>
                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name={`forms.${index}.Phone_Number`}
                                  component="div"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="single-field lg:pt-20 y-gap-20">
                                <label className="text-13 fw-500">
                                  Email{" "}
                                  {Mandatory_Fields_Array.includes("PQ002") ? (
                                    <sup className="asc">*</sup>
                                  ) : (
                                    <></>
                                  )}
                                </label>
                                <div className="form-control">
                                  <Field
                                    type="email"
                                    className="form-control"
                                    placeholder="info@yourgmail.com"
                                    name={`forms.${index}.Email_Id`}
                                    disabled={values.forms[index].self}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      const { value } = e.target;

                                      // const regex =
                                      //   /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

                                      // if (
                                      //   !value ||
                                      //   regex.test(value.toString())
                                      // ) {
                                      setFieldValue(
                                        `forms.${index}.Email_Id`,
                                        value
                                      );
                                      // } else {
                                      //   console.log("Wrong");
                                      //   return;
                                      // }
                                    }}
                                  />
                                </div>
                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name={`forms.${index}.Email_Id`}
                                  component="div"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row justify-between pt-20">
                            <div className="col-md-4">
                              <div className="single-field y-gap-20">
                                <label className="text-13 fw-500">
                                  Gender{" "}
                                  {Mandatory_Fields_Array.includes("PQ005") ? (
                                    <sup className="asc">*</sup>
                                  ) : (
                                    <></>
                                  )}
                                </label>
                                <div className="d-flex gap-15">
                                  <div className="form-radio d-flex items-center">
                                    <div className="radio">
                                      <Field
                                        type="radio"
                                        name={`forms.${index}.Gender`}
                                        value="Male"
                                      />
                                      <div className="radio__mark">
                                        <div className="radio__icon"></div>
                                      </div>
                                    </div>
                                    <div className="text-14 lh-1 ml-10">
                                      Male
                                    </div>
                                  </div>
                                  <div className="form-radio d-flex items-center">
                                    <div className="radio">
                                      <Field
                                        type="radio"
                                        name={`forms.${index}.Gender`}
                                        value="Female"
                                      />
                                      <div className="radio__mark">
                                        <div className="radio__icon"></div>
                                      </div>
                                    </div>
                                    <div className="text-14 lh-1 ml-10">
                                      Female
                                    </div>
                                  </div>
                                  <div className="form-radio d-flex items-center">
                                    <div className="radio">
                                      <Field
                                        type="radio"
                                        name={`forms.${index}.Gender`}
                                        value="Other"
                                      />
                                      <div className="radio__mark">
                                        <div className="radio__icon"></div>
                                      </div>
                                    </div>
                                    <div className="text-14 lh-1 ml-10">
                                      Other
                                    </div>
                                  </div>
                                </div>
                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name={`forms.${index}.Gender`}
                                  component="div"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="single-field lg:pt-20 y-gap-20">
                                <label className="text-13 fw-500">
                                  Blood Group{" "}
                                  {Mandatory_Fields_Array.includes("PQ006") ? (
                                    <sup className="asc">*</sup>
                                  ) : (
                                    <></>
                                  )}
                                </label>
                                <div className="p-0">
                                  <Field name={`forms.${index}.Blood_Group`}>
                                    {({ field }) => (
                                      <Select
                                        placeholder="Select"
                                        styles={selectCustomStyle}
                                        onChange={(e) => {
                                          setFieldValue(field.name, e);
                                        }}
                                        options={blood_group}
                                        value={
                                          values?.forms[index]?.Blood_Group
                                        }
                                      />
                                    )}
                                  </Field>
                                </div>

                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name={`forms.${index}.Blood_Group`}
                                  component="div"
                                />
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="single-field lg:pt-20 y-gap-20">
                                <label className="text-13 fw-500">
                                  Date Of Birth{" "}
                                  {Mandatory_Fields_Array.includes("PQ004") ? (
                                    <sup className="asc">*</sup>
                                  ) : (
                                    <></>
                                  )}
                                </label>

                                <div className="form-control">
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DesktopDatePicker
                                      className="form-control date-picker"
                                      name={`forms.${index}.Date_Of_Birth`}
                                      format="DD/MM/YYYY"
                                      inputFormat="DD/MM/YYYY"
                                      value={
                                        values.forms[index].Date_Of_Birth
                                          ? dayjs(
                                              values.forms[index].Date_Of_Birth
                                            )
                                          : null
                                      }
                                      onChange={(newValue) => {
                                        setFieldValue(
                                          `forms.${index}.Date_Of_Birth`,
                                          newValue
                                        );
                                      }}
                                      onChangeRaw={(e) => {
                                        e.preventDefault();
                                      }}
                                      // open={open}
                                      // onOpen={() => setOpen(true)}
                                      // onClose={() => setOpen(false)}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          style={{
                                            fontFamily:
                                              "Montserrat, sans-serif !important",
                                          }}
                                          fullWidth
                                          className="form-control"
                                        />
                                      )}
                                      slotProps={{
                                        inputAdornment: {
                                          position: "end",
                                        },
                                        textField: {
                                          onClick: () => setOpen(true),
                                          // disabled: true,
                                          style: {
                                            background: "#fff !important",
                                          },
                                        },
                                        field: {
                                          // disabled: true,
                                          readOnly: true,
                                        },
                                        openPickerIcon: {
                                          sx: {
                                            color: "#f05736",
                                          },
                                        },
                                      }}
                                      maxDate={dayjs().subtract(
                                        values.forms[index].minYear,
                                        "year"
                                      )}
                                      minDate={dayjs().subtract(
                                        values.forms[index].maxYear,
                                        "year"
                                      )}
                                    />
                                  </LocalizationProvider>
                                </div>
                                <ErrorMessage
                                  className="text-error-2 text-13"
                                  name={`forms.${index}.Date_Of_Birth`}
                                  component="div"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </FieldArray>
              </Form>
              <div className="row justify-end">
                <div className="col-auto relative">
                  <button
                    disabled={submitStepOne}
                    className="button w-full h-40 w-100 px-30 text-white rounded-22 bg-primary -dark-1 load-button"
                    type="button"
                    onClick={submitForm}
                    // disabled={!isValid}
                  >
                    {!submitStepOne && "Next"}
                    {submitStepOne && <span className="btn-spinner"></span>}
                  </button>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>
    </>
  );
};
const AddressForms = ({
  form,
  setPreviousForm,
  setForm,
  setUserQuestions,
  setQuestionFormUsers,
  Event_Id,
  updateTab,
  user,
}) => {
  const Mandatory_Fields_Array = JSON.parse(
    localStorage.getItem("Mandatory_Fields")
  );
  const [initialValue, setInitialValue] = useState([]);
  const [submitStepTwo, setSubmitStepTwo] = useState(false);

  const validationSchema = Yup.object().shape({
    addresses: Yup.array().of(
      Yup.object().shape({
        Address: Mandatory_Fields_Array.includes("AQ003")
          ? Yup.string().required("Address is Required")
          : Yup.string().nullable(),
        Street: Mandatory_Fields_Array.includes("AQ006")
          ? Yup.string().required("Street is Required")
          : Yup.string().nullable(),
        Landmark: Mandatory_Fields_Array.includes("AQ007")
          ? Yup.string().required("Landmark is Required")
          : Yup.string().nullable(),
        Pincode: Mandatory_Fields_Array.includes("AQ001")
          ? Yup.object().required("Pincode must be selected")
          : Yup.object().nullable(),
        City: Mandatory_Fields_Array.includes("AQ005")
          ? Yup.string().required("City is Required")
          : Yup.string().nullable(),
        State: Mandatory_Fields_Array.includes("AQ004")
          ? Yup.string().required("State is Required")
          : Yup.string().nullable(),
        Country: Mandatory_Fields_Array.includes("AQ002")
          ? Yup.object().required("Country must be selected")
          : Yup.object().nullable(),
        sameAsAbove: Yup.boolean(),
      })
    ),
  });
  const handleCopyPrevious = (setFieldValue, index, values) => {
    if (index > 0) {
      const prevValues = values.addresses[index - 1];
      setFieldValue(`addresses.${index}.Address`, prevValues.Address);
      setFieldValue(`addresses.${index}.Street`, prevValues.Street);
      setFieldValue(`addresses.${index}.Landmark`, prevValues.Landmark);
      setFieldValue(`addresses.${index}.Pincode`, prevValues.Pincode);
      setFieldValue(`addresses.${index}.City`, prevValues.City);
      setFieldValue(`addresses.${index}.State`, prevValues.State);
      setFieldValue(`addresses.${index}.Country`, prevValues.Country);
    }
  };
  function convertToXml(formData) {
    let xmlString = "<BookTicket>\n";

    formData.forEach((participant) => {
      xmlString += "    <AddressInfo>\n";
      xmlString += `        <Event_Booking_Participant_Id>${participant.Event_Booking_Participant_Id}</Event_Booking_Participant_Id>\n`;
      xmlString += `        <Address>${participant.Address}</Address>\n`;
      xmlString += `        <LandMark>${participant.Landmark}</LandMark>\n`;
      xmlString += `        <Country>${
        participant?.Country?.value ? participant?.Country?.value : ""
      }</Country>\n`;
      xmlString += `        <State>${participant.State}</State>\n`;
      xmlString += `        <City>${participant.City}</City>\n`;
      xmlString += `        <Street>${participant.Street}</Street>\n`;
      xmlString += `        <Pincode>${
        participant.Pincode?.value ? participant.Pincode?.value : ""
      }</Pincode>\n`;
      xmlString += "    </AddressInfo>\n";
    });

    xmlString += "</BookTicket>";

    return xmlString;
  }
  const submitStep2 = async (formValues) => {
    // const user = JSON.parse(localStorage.getItem("userProf"));
    const Booking_Id = localStorage.getItem("Booking_Id");
    const xml = convertToXml(formValues);
    const reqdata = {
      Method_Name: "Step2",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Participant_Id: user?.Participant_Id,
      Booking_Id: Booking_Id,
      Event_Id: decryptData(Event_Id),
      XMLData: xml,
      Coupon_Code: "",
    };
    try {
      setSubmitStepTwo(true);

      const result = await RestfullApiService(
        reqdata,
        "participant/book_event"
      );
      if (result?.data?.Result?.Table1[0]?.Result_Id === -1) {
        toast.error(result?.data?.Result?.Table1[0]?.Result_Description);
        return;
      }
      if (result) {
        const genderMap = {
          M: "Male",
          F: "Female",
          O: "Other",
        };
        const updatedFormSubmissionArray = formValues.map(
          (submission, index) => {
            const resultData = result?.data?.Result?.Table2[index];

            if (resultData) {
              submission.Event_Booking_Participant_Id =
                resultData.Event_Booking_Participant_Id;
              submission.Org_Id = resultData.Org_Id;
              submission.Gender =
                genderMap[resultData.Gender] || submission.Gender;
              submission.Event_Price = resultData.Event_Price;
            }

            return submission;
          }
        );
        // Set Current Form
        setForm({ addresses: updatedFormSubmissionArray });
        localStorage.setItem(
          "Step2",
          JSON.stringify(updatedFormSubmissionArray)
        );
        console.log(updatedFormSubmissionArray);
        // Set Next Form Initial Values
        console.log(result?.data);
        const userEvent = result?.data?.Result?.Table2?.map((user, index) => {
          const corresponding = updatedFormSubmissionArray[index];

          return { Display_Name: corresponding?.Display_Name, ...user };
        });
        // setQuestionFormUsers(result?.data?.Result?.Table2);
        setQuestionFormUsers(userEvent);
        setUserQuestions(result?.data?.Result?.Table3);

        sessionStorage.setItem("activetab", 3);
        return updateTab(3);
      }
    } catch (err) {
      toast.error(err?.Result?.Table1[0]?.Result_Description);
    } finally {
      setSubmitStepTwo(false);
    }
  };
  const fetchOptions = async (inputValue) => {
    if (inputValue.length !== 6) {
      return [];
    }

    try {
      const reqdata = {
        Method_Name: "pincode",
        Org_Id: user?.Org_Id,
        Session_User_Id: user?.Participant_Id,
        Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
        Option1: inputValue,
        Option2: "string",
        Option3: "string",
      };
      const response = await RestfullApiService(reqdata, "master/Par_dropdown");

      console.log(response?.data);

      return response.data.Result.Table1.map((option) => ({
        label: option.label,
        value: option.value,
      }));
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };
  const fetchLocation = async (
    inputValue,
    setFieldValue,
    setFieldTouched,
    state,
    city,
    street
  ) => {
    try {
      const reqdata = {
        Method_Name: "plocation",
        Org_Id: user?.Org_Id,
        Session_User_Id: user?.Participant_Id,
        Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
        Option1: String(inputValue),
        Option2: "string",
        Option3: "string",
      };
      const response = await RestfullApiService(reqdata, "master/Par_dropdown");

      console.log(response?.data);
      const data = response?.data?.Result?.Table1[0];

      setFieldValue(state, data?.StateName);
      setFieldValue(city, data?.District);
      setFieldValue(street, data?.OfficeName);
      setTimeout(() => {
        setFieldTouched(data?.StateName, true);
        setFieldTouched(data?.District, true);
        setFieldTouched(data?.OfficeName, true);
      });
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    }
  };
  const clearLocation = async (setFieldValue, state, city, street) => {
    setFieldValue(state, "");
    setFieldValue(city, "");
    setFieldValue(street, "");
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const editing = sessionStorage.getItem("editing");
    const formDone = sessionStorage.getItem("formDone");

    // if (formDone && editing) {
    const step1 = JSON.parse(localStorage.getItem("Step1"));
    const step2 = JSON.parse(localStorage.getItem("Step2"));

    console.log(step2);

    let updatedArray2 = [];

    if (step2) {
      updatedArray2 = step2.map((participant, id) => {
        const corresponding = step1[id];
        participant.Participant_Name = corresponding.Name;
        return participant;
      });

      setInitialValue(updatedArray2);
    } else {
      console.log(form);
      setInitialValue(form?.addresses);
    }
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={{ addresses: initialValue }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        submitStep2(values?.addresses);
      }}
    >
      {({ values, isValid, submitForm, setFieldValue, setFieldTouched }) => (
        <div>
          <Form>
            <FieldArray name="addresses">
              {({ insert, remove, push }) => (
                <div>
                  {values.addresses.map((address, index) => (
                    <div
                      key={index}
                      className={`shadow-2 px-40 lg:px-20 py-40 rounded-16 pb-20 mt-20 mb-20`}
                    >
                      <div className="row justify-between border-bottom-light pb-30 items-center">
                        <div className="col-auto d-flex x-gap-20 items-center">
                          <div className="size-30 rounded-full flex-center bg-yellow-1 text-dark-1 fw-600">
                            {index + 1}
                          </div>
                          <div className="text-14 text-primary fw-600 word-break">
                            {address.Display_Name} ( {address.Participant_Name}{" "}
                            )
                          </div>
                        </div>
                        {/* {index === 0 ? ( */}
                        <div className="col-auto lg:mt-10">
                          <div className="d-flex items-center">
                            <div className="text-14 lh-12 mr-10">
                              Copy Address from Profile
                            </div>
                            <div className={`form-checkbox`}>
                              <Field
                                type="checkbox"
                                name={`addresses.${index}.self`}
                                value="true"
                                checked={values.addresses[index].self}
                                onClick={(e) => {
                                  // console.log(values.forms[index]);
                                  if (!e.target.checked) {
                                    setFieldValue(
                                      `addresses.${index}.Pincode`,
                                      null
                                    );
                                    setFieldValue(
                                      `addresses.${index}.State`,
                                      ``
                                    );
                                    setFieldValue(
                                      `addresses.${index}.City`,
                                      ``
                                    );
                                    setFieldValue(
                                      `addresses.${index}.Street`,
                                      ``
                                    );
                                    setFieldValue(
                                      `addresses.${index}.Address`,
                                      ``
                                    );
                                    setFieldValue(
                                      `addresses.${index}.Landmark`,
                                      ``
                                    );
                                  } else {
                                    console.log(user?.Pincode);
                                    if (user?.Pincode) {
                                      setFieldValue(
                                        `addresses.${index}.Pincode`,
                                        {
                                          label: user?.Pincode,
                                          value: user?.Pincode,
                                        }
                                      );
                                      // setTimeout(() => {
                                      //   setFieldTouched(
                                      //     `addresses.${index}.Pincode`,
                                      //     true
                                      //   );
                                      // });
                                    }
                                    if (user?.State_Id) {
                                      setFieldValue(
                                        `addresses.${index}.State`,
                                        `${user?.State_Id}`
                                      );
                                    }
                                    if (user?.City_Id) {
                                      setFieldValue(
                                        `addresses.${index}.City`,
                                        `${user?.City_Id}`
                                      );
                                    }
                                    if (user?.Street) {
                                      setFieldValue(
                                        `addresses.${index}.Street`,
                                        `${user?.Street}`
                                      );
                                    }
                                    if (user?.Address) {
                                      setFieldValue(
                                        `addresses.${index}.Address`,
                                        `${user?.Address}`
                                      );
                                    }
                                    if (user?.Landmark) {
                                      setFieldValue(
                                        `addresses.${index}.Landmark`,
                                        `${user?.Landmark}`
                                      );
                                    }
                                  }
                                }}
                              />
                              <div className="form-checkbox__mark">
                                <div className="form-checkbox__icon fas fa-check"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* // ) : (
                        //   <div className="col-auto lg:mt-10">
                        //     <div className="d-flex items-center lg:mt-10">
                        //       <div className="text-14 lh-12 mr-10">
                        //         Same as above
                        //       </div>
                        //       <div className="form-checkbox">
                        //         <Field
                        //           type="checkbox"
                        //           name={`addresses.${index}.sameAsAbove`}
                        //           value="true"
                        //           checked={values.addresses[index].sameAsAbove}
                        //           onChange={(e) => {
                        //             const checked = e.target.checked;
                        //             setFieldValue(
                        //               `addresses.${index}.sameAsAbove`,
                        //               checked
                        //             );
                        //             if (checked) {
                        //               handleCopyPrevious(
                        //                 setFieldValue,
                        //                 index,
                        //                 values
                        //               );
                        //             }
                        //           }}
                        //         />
                        //         <div className="form-checkbox__mark">
                        //           <div className="form-checkbox__icon fas fa-check"></div>
                        //         </div>
                        //       </div>
                        //     </div>
                        //   </div>
                        // )} */}
                      </div>
                      <div className="row justify-between pt-20">
                        <div className="col-md-4">
                          <div className="single-field y-gap-20">
                            <label className="text-13 fw-500">
                              Pincode/Zipcode/Postcode{" "}
                              {Mandatory_Fields_Array.includes("AQ001") ? (
                                <sup className="asc">*</sup>
                              ) : (
                                <></>
                              )}
                            </label>
                            <div className="p-0">
                              <Field name={`addresses.${index}.Pincode`}>
                                {({ field }) => (
                                  <AsyncSelect
                                    className="select-color"
                                    placeholder="Pincode"
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={fetchOptions}
                                    styles={selectCustomStyle}
                                    onChange={(e) => {
                                      console.log(e);
                                      console.log(field.name);
                                      setFieldValue(field.name, e);
                                      if (e === null || e === undefined) {
                                        console.log("Select cleared");
                                        // Run your custom function here
                                        clearLocation(
                                          setFieldValue,
                                          `addresses.${index}.State`,
                                          `addresses.${index}.City`,
                                          `addresses.${index}.Street`
                                        );
                                        setTimeout(() => {
                                          setFieldTouched(
                                            `addresses.${index}.State`,
                                            true
                                          );
                                          setFieldTouched(
                                            `addresses.${index}.City`,
                                            true
                                          );
                                          setFieldTouched(
                                            `addresses.${index}.Street`,
                                            true
                                          );
                                        });
                                      } else {
                                        fetchLocation(
                                          e.value,
                                          setFieldValue,
                                          setFieldTouched,
                                          `addresses.${index}.State`,
                                          `addresses.${index}.City`,
                                          `addresses.${index}.Street`
                                        );
                                      }
                                    }}
                                    value={values.addresses[index]?.Pincode}
                                    isClearable
                                  />
                                )}
                              </Field>
                            </div>
                            <ErrorMessage
                              className="text-error-2 text-13"
                              name={`addresses.${index}.Pincode`}
                              component="div"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="single-field lg:pt-20 y-gap-20">
                            <label className="text-13 fw-500">
                              Country{" "}
                              {Mandatory_Fields_Array.includes("AQ002") ? (
                                <sup className="asc">*</sup>
                              ) : (
                                <></>
                              )}
                            </label>

                            <div className="p-0">
                              <Field
                                disabled
                                name={`addresses.${index}.Country`}
                              >
                                {({ field }) => (
                                  <Select
                                    isDisabled
                                    placeholder="Country"
                                    styles={disabledCustomStyle}
                                    onChange={(e) => {
                                      setFieldValue(field.name, e);
                                    }}
                                    options={[
                                      {
                                        label: "India",
                                        value: "India",
                                      },
                                    ]}
                                    value={values?.addresses[index].Country}
                                  />
                                )}
                              </Field>
                            </div>
                            <ErrorMessage
                              className="text-error-2 text-13"
                              name={`addresses.${index}.Country`}
                              component="div"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="single-field lg:pt-20 y-gap-20">
                            <label className="text-13 fw-500">
                              State{" "}
                              {Mandatory_Fields_Array.includes("AQ004") ? (
                                <sup className="asc">*</sup>
                              ) : (
                                <></>
                              )}
                            </label>
                            <div className="form-control">
                              <Field
                                disabled
                                type="text"
                                className="form-control"
                                placeholder="State"
                                name={`addresses.${index}.State`}
                              />
                            </div>
                            <ErrorMessage
                              className="text-error-2 text-13"
                              name={`addresses.${index}.State`}
                              component="div"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row justify-between pt-20">
                        <div className="col-md-4">
                          <div className="single-field y-gap-20">
                            <label className="text-13 fw-500">
                              City{" "}
                              {Mandatory_Fields_Array.includes("AQ005") ? (
                                <sup className="asc">*</sup>
                              ) : (
                                <></>
                              )}
                            </label>
                            <div className="form-control">
                              <Field
                                disabled
                                type="text"
                                className="form-control"
                                placeholder="City"
                                name={`addresses.${index}.City`}
                              />
                            </div>
                            <ErrorMessage
                              className="text-error-2 text-13"
                              name={`addresses.${index}.City`}
                              component="div"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="single-field lg:pt-20 y-gap-20">
                            <label className="text-13 fw-500">
                              Address{" "}
                              {Mandatory_Fields_Array.includes("AQ003") ? (
                                <sup className="asc">*</sup>
                              ) : (
                                <></>
                              )}
                            </label>
                            <div className="form-control">
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Full Address"
                                name={`addresses.${index}.Address`}
                                maxLength="100"
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;

                                  // Regular expression to allow alphanumeric characters and spaces but no leading spaces
                                  // const regex =
                                  // /^[a-zA-Z0-9][a-zA-Z0-9\s,\.]*$/;
                                  const regex =
                                    /^[a-zA-Z0-9!-\/:-@[-`{-~][a-zA-Z0-9\s!-\/:-@[-`{-~]*$/;

                                  if (!value || regex.test(value.toString())) {
                                    setFieldValue(
                                      `addresses.${index}.Address`,
                                      value
                                    );
                                  } else {
                                    return;
                                  }
                                }}
                              />
                            </div>
                            <ErrorMessage
                              className="text-error-2 text-13"
                              name={`addresses.${index}.Address`}
                              component="div"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="single-field lg:pt-20 y-gap-20">
                            <label className="text-13 fw-500">
                              Street{" "}
                              {Mandatory_Fields_Array.includes("AQ006") ? (
                                <sup className="asc">*</sup>
                              ) : (
                                <></>
                              )}
                            </label>
                            <div className="form-control">
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Street"
                                maxLength="100"
                                name={`addresses.${index}.Street`}
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;

                                  const regex =
                                    /^[a-zA-Z0-9!-\/:-@[-`{-~][a-zA-Z0-9\s!-\/:-@[-`{-~]*$/;

                                  if (!value || regex.test(value.toString())) {
                                    setFieldValue(
                                      `addresses.${index}.Street`,
                                      value
                                    );
                                  } else {
                                    return;
                                  }
                                }}
                              />
                            </div>
                            <ErrorMessage
                              className="text-error-2 text-13"
                              name={`addresses.${index}.Street`}
                              component="div"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row justify-between pt-20">
                        <div className="col-md-8">
                          <div className="single-field y-gap-20">
                            <label className="text-13 fw-500">
                              Landmark{" "}
                              {Mandatory_Fields_Array.includes("AQ007") ? (
                                <sup className="asc">*</sup>
                              ) : (
                                <></>
                              )}
                            </label>
                            <div className="form-control">
                              <Field
                                type="text"
                                className="form-control"
                                placeholder="Landmark"
                                maxLength="100"
                                name={`addresses.${index}.Landmark`}
                                onChange={(e) => {
                                  e.preventDefault();
                                  const { value } = e.target;

                                  // Regular expression to allow alphanumeric characters and spaces but no leading spaces
                                  // const regex =
                                  //   /^[a-zA-Z0-9][a-zA-Z0-9\s,\.]*$/;
                                  const regex =
                                    /^[a-zA-Z0-9!-\/:-@[-`{-~][a-zA-Z0-9\s!-\/:-@[-`{-~]*$/;

                                  if (!value || regex.test(value.toString())) {
                                    setFieldValue(
                                      `addresses.${index}.Landmark`,
                                      value
                                    );
                                  } else {
                                    return;
                                  }
                                }}
                              />
                            </div>
                            <ErrorMessage
                              className="text-error-2 text-13"
                              name={`addresses.${index}.Landmark`}
                              component="div"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </FieldArray>
            <div className="row justify-end">
              <div className="col-auto d-flex">
                <button
                  className="button px-30 py-10 border-primary text-primary rounded-22 -primary-1 js-prev"
                  onClick={() => {
                    updateTab(1);
                  }}
                >
                  Previous
                </button>
                <div className="col-auto relative relative">
                  <button
                    disabled={submitStepTwo}
                    className="button w-full h-40 w-100 px-30 text-white rounded-22 bg-primary -dark-1 ml-10 load-button"
                    type="button"
                    onClick={submitForm}
                  >
                    {!submitStepTwo && "Next"}
                    {submitStepTwo && <span className="btn-spinner"></span>}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      )}
    </Formik>
  );
};
const QuestionForms = ({
  users,
  userQuestions,
  setPreviousForm,
  Event_Id,
  updateTab,
  editing,
  setEditing,
  formDone,
  setFormDone,
  user,
}) => {
  const [submitStepThree, setSubmitStepThree] = useState(false);
  const [initValue, setInitValue] = useState([]);
  const [validation, setValidation] = useState({});
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "#f05736",
      boxShadow: theme.shadows[1],
      fontSize: 11,
      fontFamily: "Montserrat, sans-serif",
      letterSpacing: "0.05em",
    },
  }));
  const transformInitialValues = (initialValues) => {
    return initialValues.map((user) => {
      const fields = user.fields.reduce((acc, field) => {
        const key = Object.keys(field)[0];
        acc[key] = field[key];
        return acc;
      }, {});

      return {
        ...user,
        fields: [fields],
      };
    });
  };
  const generateValidationSchema = (userQuestions) => {
    // Define a base schema for field validations
    const fieldSchema = userQuestions.reduce((schema, question) => {
      const { Event_Question_Id, Is_Mandatory, Input_Type, Mandatory_Msg } =
        question;

      let fieldValidation = Yup.string(); // Default to string validation

      if (Is_Mandatory === 1) {
        if (Input_Type === "checkbox") {
          console.log("Here");
          fieldValidation = Yup.boolean().oneOf([true], Mandatory_Msg);
        } else if (Input_Type === "phone") {
          fieldValidation = Yup.string()
            .matches(/^[0-9]{10}$/, "Phone number is not valid")
            .required(Mandatory_Msg)
            .test(
              "uniquePhoneNumber",
              "Emergency contact number must be different from the Participant number",
              (value) => {
                return value !== user?.Phone_Number;
              }
            );
        } else {
          fieldValidation = Yup.string().required(Mandatory_Msg);
        }
        // if (Input_Type === "select") {
        //   fieldValidation = Yup.object().required(Mandatory_Msg);
        // }
      }

      return {
        ...schema,
        [Event_Question_Id]: fieldValidation,
      };
    }, {});

    console.log(fieldSchema);

    return Yup.object().shape({
      users: Yup.array().of(
        Yup.object().shape({
          id: Yup.string().required("Event Participant ID is required"),
          name: Yup.string().required("Name is required"),
          fields: Yup.array().of(
            Yup.object().shape({
              ...fieldSchema,
            })
          ),
        })
      ),
    });
  };
  const convertToXml = (values) => {
    let xml = "<BookTicket>\n";

    console.log(values?.users);

    values?.users?.forEach((user) => {
      user.fields.forEach((field) => {
        Object.entries(field).forEach(([key, value]) => {
          xml += `  <QuestionInfo>\n    <Event_Booking_Participant_Id>${user.id}</Event_Booking_Participant_Id>\n    <Event_Question_Id>${key}</Event_Question_Id>\n    <Answer>${value}</Answer>\n  </QuestionInfo>\n`;
        });
      });
    });

    xml += "</BookTicket>";
    return xml;
  };
  const submitStep3 = async (formValues) => {
    // const user = JSON.parse(localStorage.getItem("userProf"));
    const Booking_Id = localStorage.getItem("Booking_Id");
    const xml = convertToXml(formValues);
    const reqdata = {
      Method_Name: "Step3",
      Org_Id: user?.Org_Id,
      Session_User_Id: user?.Participant_Id,
      Session_User_Name: `${user?.First_Name} ${user?.Last_Name}`,
      Participant_Id: user?.Participant_Id,
      Booking_Id: Booking_Id,
      Event_Id: decryptData(Event_Id),
      XMLData: xml,
      Coupon_Code: "",
    };
    try {
      setSubmitStepThree(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/book_event"
      );
      if (result?.data?.Result?.Table1[0]?.Result_Id === -1) {
        toast.error(result?.data?.Result?.Table1[0]?.Result_Description);
        return;
      }
      if (result) {
        console.log(result?.data);

        // transformedInitialValues = formValues;

        // localStorage.setItem("users", JSON.stringify(users));
        // localStorage.setItem("userQuestions", JSON.stringify(userQuestions));
        localStorage.setItem("validation", JSON.stringify(validation));
        localStorage.setItem("Step3", JSON.stringify(formValues?.users));
        localStorage.setItem("eventId", Event_Id);
        localStorage.setItem(
          "paymentDetails",
          JSON.stringify(result?.data?.Result?.Table2[0])
        );
        localStorage.setItem(
          "registeredParticipants",
          JSON.stringify(result?.data?.Result?.Table3)
        );

        // navigate("/payment-details");
        sessionStorage.setItem("formDone", !formDone);
        sessionStorage.setItem("editing", !editing);
        setEditing(false);
      }
    } catch (err) {
      toast.error(err?.Result?.Table1[0]?.Result_Description);
    } finally {
      setSubmitStepThree(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    // const editing = sessionStorage.getItem("editing");
    // const formDone = sessionStorage.getItem("formDone");

    // if (formDone && editing) {
    const step1 = JSON.parse(localStorage.getItem("Step1"));
    const step3 = JSON.parse(localStorage.getItem("Step3"));

    console.log(step3);

    let updatedArray3 = [];

    if (step3) {
      updatedArray3 = step3.map((participant, id) => {
        const corresponding = step1[id];
        participant.name = corresponding.Name;
        return participant;
      });

      setInitValue(updatedArray3);
    } else {
      const initialValues = users?.map((user) => {
        const {
          Display_Name,
          Event_Booking_Participant_Id,
          First_Name,
          Last_Name,
        } = user;
        const userName = `${First_Name} ${Last_Name}`;

        // Create an array of fields based on userQuestions
        const fields = userQuestions.map((question) => {
          if (question.Input_Type === "checkbox") {
            return {
              [question.Event_Question_Id]: true, // Initialize each field with an empty string
            };
          } else {
            return {
              [question.Event_Question_Id]: "", // Initialize each field with an empty string
            };
          }
        });

        return {
          id: Event_Booking_Participant_Id,
          Display_Name: Display_Name,
          name: userName,
          fields: fields,
        };
      });

      let transformedInitialValues = transformInitialValues(initialValues);

      console.log(transformedInitialValues);
      if (transformedInitialValues) {
        setInitValue(transformedInitialValues);
      }
    }

    const validationSchema = generateValidationSchema(userQuestions);

    if (validationSchema) {
      setValidation(validationSchema);
    }
  }, [userQuestions]);

  return (
    <Formik
      enableReinitialize
      initialValues={{ users: initValue }}
      validationSchema={validation}
      onSubmit={(values) => {
        console.log(values);
        submitStep3(values);
      }}
    >
      {({
        values,
        isValid,
        submitForm,
        setFieldValue,
        setFieldTouched,
        handleChange,
        handleBlur,
        errors,
        touched,
      }) => (
        <div>
          <Form>
            <FieldArray name="users">
              {({ insert, remove, push }) => {
                return (
                  <div>
                    {values.users.map((user, userIndex) => {
                      return (
                        <div
                          key={user?.id}
                          className="shadow-2 px-40 lg:px-20 py-40 rounded-16 pb-20 mt-20 mb-20"
                        >
                          <div className="row justify-between border-bottom-light pb-30 items-center">
                            <div className="col-auto d-flex x-gap-20 items-center">
                              <div className="size-30 rounded-full flex-center bg-yellow-1 text-dark-1 fw-600">
                                {userIndex + 1}
                              </div>
                              <div className="text-14 text-primary fw-600 word-break">
                                {user?.Display_Name} ( {user?.name} )
                              </div>
                            </div>
                          </div>
                          <div>
                            <FieldArray name={`users.${userIndex}.fields`}>
                              {() => (
                                <div className="row pt-20">
                                  {Object.keys(user.fields[0])?.map(
                                    (fieldId, fieldIndex) => {
                                      const question = userQuestions?.find(
                                        (q) => q.Event_Question_Id === fieldId
                                      );
                                      if (!question) return null;

                                      const inputProps = {
                                        // name: `users.${userIndex}.fields.${fieldIndex}.${fieldId}`,
                                        // name: `users.${userIndex}.fields.${fieldIndex}[${fieldId}]`,
                                        name: `users.${userIndex}.fields.${0}.${fieldId}`,
                                        onChange: handleChange,
                                        onBlur: handleBlur,
                                        value:
                                          values.users[userIndex].fields[0][
                                            fieldId
                                          ],
                                        label: question.Question,
                                      };

                                      return (
                                        <div
                                          key={fieldId}
                                          className={`${
                                            question.Option_Fileds?.split(",")
                                              ?.length > 5 &&
                                            question.Input_Type === "checkbox"
                                              ? "col-md-8"
                                              : "col-md-4"
                                          } mb-20`}
                                        >
                                          <div
                                            className={`single-field y-gap-20 ${
                                              question.Input_Type === "File" &&
                                              "upload"
                                            }`}
                                          >
                                            {question.Question.length > 50 ? (
                                              <LightTooltip
                                                title={question.Question}
                                                placement="top-start"
                                                slotProps={{
                                                  popper: {
                                                    modifiers: [
                                                      {
                                                        name: "offset",
                                                        options: {
                                                          offset: [0, -20],
                                                        },
                                                      },
                                                    ],
                                                  },
                                                }}
                                                enterTouchDelay={20}
                                              >
                                                <label className="text-13 fw-500">
                                                  {question.Question.length > 50
                                                    ? question.Question.substring(
                                                        0,
                                                        50
                                                      ) + "..."
                                                    : question.Question}
                                                  {question.Is_Mandatory ? (
                                                    <sup className="asc">*</sup>
                                                  ) : null}
                                                </label>
                                              </LightTooltip>
                                            ) : (
                                              <label
                                                className="text-13 fw-500"
                                                style={{
                                                  display:
                                                    question.Input_Type ===
                                                    "checkbox"
                                                      ? // ? "none"
                                                        "block"
                                                      : "block",
                                                }}
                                              >
                                                {question.Option_Fileds ===
                                                "TC" ? (
                                                  <>
                                                    I agree to the{" "}
                                                    <span className="text-12">
                                                      <Link
                                                        // href="https://admin.fitizenindia.com/UploadFiles/TermsCondition/fitizen/Standard%20Terms%20and%20Conditions%20of%20Service.docx"
                                                        href={`${MEDIA_URL}${question.Doc_Path}`}
                                                        underline="always"
                                                        color="#f05736"
                                                      >
                                                        TERMS & CONDITIONS
                                                      </Link>
                                                    </span>
                                                  </>
                                                ) : (
                                                  // question.Question
                                                  question.Question
                                                )}{" "}
                                                {question.Is_Mandatory ? (
                                                  <sup className="asc">*</sup>
                                                ) : null}
                                              </label>
                                            )}

                                            <div
                                              className={`${
                                                question.Input_Type !==
                                                  "radio" &&
                                                question.Input_Type !==
                                                  "checkbox"
                                                  ? "form-control"
                                                  : ""
                                              }`}
                                              style={{}}
                                            >
                                              {question.Input_Type ===
                                              "checkbox" ? (
                                                <Stack direction="row" gap={1}>
                                                  <div
                                                    class="d-flex items-center"
                                                    style={{ width: "5%" }}
                                                  >
                                                    <Field
                                                      className="w-full p-0"
                                                      type="checkbox"
                                                      {...inputProps}
                                                      checked={
                                                        values.users[userIndex]
                                                          .fields[0][fieldId]
                                                      }
                                                    />
                                                  </div>
                                                  <p className="text-14 fw-500">
                                                    Yes
                                                  </p>
                                                </Stack>
                                              ) : question.Input_Type ===
                                                "radio" ? (
                                                <div className="d-flex gap-20">
                                                  {question.Option_Fileds.split(
                                                    ","
                                                  ).map((option, idx) => (
                                                    // <label
                                                    //   className="d-flex items-center gap-5 text-14"
                                                    //   key={idx}
                                                    // >
                                                    //   <Field
                                                    //     type="radio"
                                                    //     className="p-0"
                                                    //     {...inputProps}
                                                    //     value={option}
                                                    //     checked={
                                                    //       values.users[
                                                    //         userIndex
                                                    //       ].fields[0][
                                                    //         fieldId
                                                    //       ] === option
                                                    //     }
                                                    //   />
                                                    //   {option}
                                                    // </label>
                                                    <div
                                                      className="form-radio d-flex items-center"
                                                      key={idx}
                                                    >
                                                      <div className="radio">
                                                        <Field
                                                          type="radio"
                                                          className="p-0"
                                                          {...inputProps}
                                                          value={option}
                                                          checked={
                                                            values.users[
                                                              userIndex
                                                            ].fields[0][
                                                              fieldId
                                                            ] === option
                                                          }
                                                        />
                                                        <div className="radio__mark">
                                                          <div className="radio__icon"></div>
                                                        </div>
                                                      </div>
                                                      <div className="text-14 lh-1 ml-10">
                                                        {option}
                                                      </div>
                                                    </div>
                                                  ))}
                                                </div>
                                              ) : question.Input_Type ===
                                                  "select" ||
                                                question.Input_Type ===
                                                  "dropdown" ? (
                                                <Field
                                                  as="select"
                                                  {...inputProps}
                                                >
                                                  <option value="">
                                                    Select
                                                  </option>
                                                  {question.Option_Fileds.split(
                                                    ","
                                                  ).map((option, idx) => (
                                                    <option
                                                      key={idx}
                                                      value={option}
                                                    >
                                                      {option}
                                                    </option>
                                                  ))}
                                                </Field>
                                              ) : question.Input_Type ===
                                                "File" ? (
                                                <div className="d-flex items-center x-gap-10 pl-5">
                                                  <button class="upload__btn">
                                                    Upload a file
                                                  </button>
                                                  <div className="d-flex items-center p-0">
                                                    <div className="d-flex items-center ml-5">
                                                      <input
                                                        type="file"
                                                        class="form-control upload__input"
                                                        accept="image/*"
                                                        name={inputProps.name}
                                                        onChange={async (
                                                          event
                                                        ) => {
                                                          const file =
                                                            event.currentTarget
                                                              .files[0];

                                                          // Check if the file is an image
                                                          if (
                                                            file &&
                                                            !file.type.startsWith(
                                                              "image/"
                                                            )
                                                          ) {
                                                            toast.error(
                                                              "Please upload an image."
                                                            );
                                                            event.target.value =
                                                              ""; // Reset the input value
                                                            return;
                                                          }
                                                          // Check if the file size is above 2MB (2 * 1024 * 1024 bytes)
                                                          const maxSize =
                                                            2 * 1024 * 1024;
                                                          if (
                                                            file &&
                                                            file.size > maxSize
                                                          ) {
                                                            toast.error(
                                                              "File size should not exceed 2MB."
                                                            );
                                                            event.target.value =
                                                              ""; // Reset the input value
                                                            return;
                                                          }
                                                          // if (
                                                          //   !event.currentTarget
                                                          //     .files.length
                                                          // )
                                                          //   return; // Avoid duplicate uploads

                                                          const reqdata =
                                                            new FormData();
                                                          reqdata.append(
                                                            "ModuleName",
                                                            `EventbookingDocument/${user.id}`
                                                          );
                                                          reqdata.append(
                                                            "File",
                                                            event.currentTarget
                                                              .files[0]
                                                          );
                                                          toast.promise(
                                                            RestfullApiService(
                                                              reqdata,
                                                              "participant/uploadfile"
                                                            ),
                                                            {
                                                              loading:
                                                                "Uploading... Please wait",
                                                              success: (
                                                                result
                                                              ) => {
                                                                if (result) {
                                                                  console.log(
                                                                    result
                                                                  );
                                                                  setFieldValue(
                                                                    inputProps.name,
                                                                    result?.data
                                                                      ?.Description
                                                                  );
                                                                }
                                                                return "Upload successful!";
                                                              },
                                                              error: (err) => {
                                                                const errorMessage =
                                                                  err?.Result
                                                                    ?.Table1[0]
                                                                    ?.Result_Description ||
                                                                  "Upload failed";
                                                                return errorMessage;
                                                              },
                                                            }
                                                          );
                                                        }}
                                                        onBlur={
                                                          inputProps.onBlur
                                                        }
                                                      />
                                                    </div>
                                                    {values.users[userIndex]
                                                      .fields[0][fieldId] && (
                                                      <div class="text-14 lh-12 ml-10 mr-15">
                                                        {values.users[userIndex]
                                                          .fields[0][fieldId]
                                                          ? `...${values.users[
                                                              userIndex
                                                            ].fields[0][
                                                              fieldId
                                                            ].slice(
                                                              values.users[
                                                                userIndex
                                                              ].fields[0][
                                                                fieldId
                                                              ].length - 10
                                                            )}`
                                                          : ""}
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              ) : question.Input_Type ===
                                                "phone" ? (
                                                <Field
                                                  type="tel"
                                                  className="form-control"
                                                  placeholder="000 000 0000"
                                                  name={`users.${userIndex}.fields.${0}.${fieldId}`}
                                                  maxLength="10"
                                                  onChange={(e) => {
                                                    e.preventDefault();
                                                    const { value } = e.target;
                                                    console.log(value);

                                                    // Regular expression to allow only numbers
                                                    const regex = /^[0-9\b]+$/;

                                                    if (
                                                      !value ||
                                                      regex.test(
                                                        value.toString()
                                                      )
                                                    ) {
                                                      console.log(value);
                                                      setFieldValue(
                                                        `users.${userIndex}.fields.${0}.${fieldId}`,
                                                        value
                                                      );
                                                    } else {
                                                      return;
                                                    }
                                                  }}
                                                  onBlur={handleBlur}
                                                  // {...inputProps}
                                                />
                                              ) : (
                                                <Field
                                                  type={question.Input_Type}
                                                  className="form-control"
                                                  maxLength="50"
                                                  name={`users.${userIndex}.fields.${0}.${fieldId}`}
                                                  onChange={(e) => {
                                                    e.preventDefault();
                                                    const { value } = e.target;

                                                    const regex =
                                                      // /^[a-zA-Z][a-zA-Z\s]*$/;
                                                      /^[a-zA-Z0-9](?!.* {2,})[a-zA-Z0-9 ]*$/;
                                                    if (
                                                      !value ||
                                                      regex.test(value)
                                                    ) {
                                                      console.log(value);
                                                      setFieldValue(
                                                        `users.${userIndex}.fields.${0}.${fieldId}`,
                                                        value
                                                      );
                                                    } else {
                                                      return;
                                                    }
                                                  }}
                                                  onBlur={handleBlur}
                                                />
                                              )}
                                            </div>
                                            <ErrorMessage
                                              className="text-error-2 text-13"
                                              name={`users.${userIndex}.fields.${0}.${fieldId}`}
                                              component="div"
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              )}
                            </FieldArray>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              }}
            </FieldArray>
            <div className="row justify-end ">
              <div className="col-auto d-flex">
                <button
                  className="button px-30 py-10 border-primary text-primary rounded-22 -primary-1 js-prev"
                  onClick={() => {
                    updateTab(2);
                  }}
                >
                  Previous
                </button>
                <div className="col-auto relative">
                  <button
                    className="button w-full h-40 w-100 px-30 text-white rounded-22 bg-primary -dark-1 ml-10 load-button"
                    type="button"
                    onClick={() => {
                      console.log(errors);
                      submitForm();
                    }}
                    disabled={submitStepThree}
                  >
                    {!submitStepThree && "Next"}
                    {submitStepThree && <span className="btn-spinner"></span>}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      )}
    </Formik>
  );
};

function EventUserDetails() {
  const { event_id } = useParams();
  const [personalInfoforms, setPersonalInfoForms] = useState([]);
  const [addressInfoforms, setAddressInfoForms] = useState([]);
  const [userQuestions, setUserQuestions] = useState([]);
  const [questionFormUsers, setQuestionFormUsers] = useState([]);
  const [editing, setEditing] = useState(true);
  const [formDone, setFormDone] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const user = useSelector((state) => state.user.userProfile);

  const updateTab = (tabNumber) => {
    setActiveTab(tabNumber);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    const alreadySelected = JSON.parse(
      localStorage.getItem("selectedCategories")
    );
    const initialForms = {
      forms: alreadySelected?.flatMap((event) =>
        Array.from({ length: event.count }, () => ({
          eventId: event?.EventCategory_Id,
          eventName: event?.EventCategory_Name,
          maxYear: event?.Eligibility_Criteria_MaxYear,
          minYear: event?.Eligibility_Criteria_MinYear,
          Name: "",
          Phone_Number: "",
          Email_Id: "",
          Gender: "",
          Date_Of_Birth: null,
          Blood_Group: "",
          sameAsAbove: false,
          self: false,
          isValid: false,
        }))
      ),
    };
    console.log(initialForms);
    setPersonalInfoForms(initialForms);
  }, []);

  return (
    <>
      {!editing ? (
        <PaymentDetails
          editing={editing}
          setEditing={setEditing}
          setActiveTab={setActiveTab}
        />
      ) : (
        <section
          style={{ marginTop: "80px" }}
          className="layout-pt-sm layout-pb-md"
        >
          <div className="container">
            <div className="tabs -pills-2">
              <div className="row x-gap-40 y-gap-30 items-center justify-center tabs__controls">
                <div className="col-auto">
                  <div className="d-flex items-center">
                    <div
                      className={`size-40 rounded-full flex-center ${
                        activeTab === 1 ||
                        activeTab - 1 === 1 ||
                        activeTab - 2 === 1
                          ? "bg-primary"
                          : "bg-blue-1-05"
                      } tabs__button`}
                      // className={`size-40 rounded-full flex-center ${
                      //   activeTab === 1 && "bg-primary"
                      // } tabs__button`}
                      // className={`size-40 rounded-full flex-center bg-primary tabs__button`}
                    >
                      <i className="fas fa-check text-16 text-white"></i>
                    </div>
                    <div>
                      <p className="text-14 fw-500 ml-10">Step 1</p>
                      <p className="text-13 fw-400 ml-10 lg:d-none">
                        Personal Information
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col lg:d-none">
                  <div className="w-full h-1 bg-border"></div>
                </div>

                <div className="col-auto">
                  <div className="d-flex items-center">
                    <div
                      className={`size-40 rounded-full flex-center ${
                        activeTab === 2 || activeTab - 1 === 2
                          ? "bg-primary"
                          : "bg-blue-1-05"
                      } tabs__button`}
                      // className={`size-40 rounded-full flex-center ${
                      //   activeTab === 2 && "bg-primary"
                      // } tabs__button`}
                    >
                      <i className="fas fa-check text-16 text-white"></i>
                    </div>
                    <div>
                      <p className="text-14 fw-500 ml-10">Step 2</p>
                      <p className="text-13 fw-400 ml-10 lg:d-none">
                        Address Information
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col lg:d-none">
                  <div className="w-full h-1 bg-border"></div>
                </div>

                <div className="col-auto">
                  <div className="d-flex items-center">
                    <div
                      className={`size-40 rounded-full flex-center ${
                        activeTab === 3 ? "bg-primary" : "bg-blue-1-05"
                      } tabs__button`}
                      // className={`size-40 rounded-full flex-center ${
                      //   activeTab === 3 && "bg-primary"
                      // } tabs__button`}
                    >
                      <i className="fas fa-check text-16 text-white"></i>
                    </div>
                    <div>
                      <p className="text-14 fw-500 ml-10">Step 3</p>
                      <p className="text-13 fw-400 ml-10 lg:d-none">
                        Additional Information
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tabs__content pt-20 js-tabs-content">
                {activeTab === 1 && (
                  <>
                    <div
                      className={`tabs__pane ${
                        activeTab === 1 &&
                        "is-tab-el-active -tab-item-1 d-flex flex-column"
                      } `}
                    >
                      {personalInfoforms.forms?.length > 0 && (
                        <PersonalInfoForm
                          form={personalInfoforms}
                          setForm={setPersonalInfoForms}
                          setNextForm={setAddressInfoForms}
                          Event_Id={event_id}
                          updateTab={updateTab}
                          editing={editing}
                          setEditing={setEditing}
                          formDone={formDone}
                          user={user}
                        />
                      )}
                    </div>
                  </>
                )}
                {activeTab === 2 && (
                  <div
                    className={`tabs__pane ${
                      activeTab === 2 && "is-tab-el-active -tab-item-2"
                    } d-flex flex-column`}
                  >
                    {/* {addressInfoforms.addresses?.length > 0 && ( */}
                    <AddressForms
                      form={addressInfoforms}
                      setPreviousForm={setPersonalInfoForms}
                      setForm={setAddressInfoForms}
                      setUserQuestions={setUserQuestions}
                      setQuestionFormUsers={setQuestionFormUsers}
                      Event_Id={event_id}
                      updateTab={updateTab}
                      editing={editing}
                      setEditing={setEditing}
                      formDone={formDone}
                      user={user}
                    />
                    {/* )} */}
                  </div>
                )}
                {activeTab === 3 && (
                  <div
                    className={`tabs__pane ${
                      activeTab === 3 && "is-tab-el-active -tab-item-3 "
                    } d-flex flex-column`}
                    // shadow-2 px-40 py-10 rounded-8 pb-20
                  >
                    {/* {questionFormUsers?.length > 0 &&
                      userQuestions?.length > 0 && ( */}
                    <QuestionForms
                      users={questionFormUsers}
                      userQuestions={userQuestions}
                      setPreviousForm={setAddressInfoForms}
                      Event_Id={event_id}
                      updateTab={updateTab}
                      editing={editing}
                      setEditing={setEditing}
                      formDone={formDone}
                      setFormDone={setFormDone}
                      user={user}
                    />
                    {/* )} */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default EventUserDetails;

// try {
//   const result =
//     await RestfullApiService(
//       reqdata,
//       "participant/uploadfile"
//     );
//   if (result) {
//     console.log(
//       result?.data
//         ?.Description
//     );
//     setFieldValue(
//       inputProps.name,
//       result?.data
//         ?.Description
//     );
//   }
// } catch (err) {
//   toast.error(
//     err?.Result
//       ?.Table1[0]
//       ?.Result_Description
//   );
// }
//    <div
//     class={`text-14 lh-12${
//       isMobile ? " ml-10" : ""
//     }`}
//   >
//     {question.Question}{" "}
//     {question.Is_Mandatory ? (
//       <sup className="asc">
//         *
//       </sup>
//     ) : null}
//   </div>
